import React, { useMemo } from 'react';
import Link from 'next/link';
import cn from 'classnames';

import { CheckedIcon, ShoppingCartIcon } from '@components/Icon';
import { AnalysisLabels, Button, Title } from '@components/index';
import { Product } from '@graphql/generated';
import { useBasket } from '@hooks/useBasket';
import { formatPrice } from '@utils/formatPrice';
import { ADD_TO_CARD, handleSendAnalytics } from '@constants/yandexMetrikaEvents';

import AnalysisNumber from '../AnalysisNumber';
import s from './ProductCard.module.scss';
import { labIsAvailable } from '@utils/isValidLabs';
import { useDeadline } from '@hooks/useDeadline';

interface TOwnProps extends Product {
  className?: string;
  isInBasket?: boolean;
  descriptionShort?: string | null | undefined;
  biomaterial?: string | null | undefined;
}

const ProductCard: React.FC<TOwnProps & JSX.IntrinsicElements['div']> = (product) => {
  const {
    className,
    id,
    title,
    price,
    isInBasket = false,
    biomaterial,
    code,
    // deadline,
    isPackage,
    subProducts,
  } = product;
  const { onAddToBasket, onRemoveProductFromBasket } = useBasket();
  const { deadline } = useDeadline(product);

  const handleAddToBasket = async (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    await onAddToBasket(id);
    handleSendAnalytics(ADD_TO_CARD);
  };

  const handleRemoveFromBasket = async (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    await onRemoveProductFromBasket(id);
  };

  const classes = cn(s.root, isInBasket && s.white, className);

  const formatedPrice = formatPrice(price);

  const labs = useMemo(() => labIsAvailable(product), [product]);

  return (
    <Link href={`catalog/${id}`} passHref>
      <div className={classes}>
        <div className={s.titleWrapper}>
          <Title level={2} className={s.title}>
            {title}
          </Title>
          {isPackage && subProducts?.length && <AnalysisNumber number={subProducts?.length} className={s.analysis} />}
        </div>
        <AnalysisLabels
          code={code}
          biomaterial={biomaterial}
          isPackage={isPackage}
          subProducts={subProducts}
          deadline={deadline}
          labs={labs}
          showLabsLabel
        />
        {isInBasket ? (
          <Button
            theme="secondary"
            onClick={handleRemoveFromBasket}
            size="large"
            className={cn(s.iconButton, s.booked)}
            icon={<CheckedIcon />}
          />
        ) : (
          <Button
            theme="secondary"
            size="large"
            onClick={handleAddToBasket}
            className={s.iconButton}
            icon={<ShoppingCartIcon />}
          >
            {formatedPrice}
          </Button>
        )}
      </div>
    </Link>
  );
};

export default ProductCard;
